<template>
  <div>
    <!-- <div class="text-xs-center mb-5" style="font-size: 1.9em; color: #777">Forgot Password</div> -->
    <v-text-field
      dark
      v-model="email"
      label="E-mail"
    ></v-text-field>
    <br>
    <v-btn flat class="password-reset__submit-button" @click.native="submitForgotPassword"><p>Request Password Reset</p></v-btn>
    <br>
    <v-btn flat class="password-reset__redirect-login" @click="setUrlHash('login')"><p>Back to Login</p></v-btn>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'reset_password',
  data () {
    return {
      email: ''
    }
  },
  methods: {
    ...mapActions([
      'setAuthModalOpen',
      'setSnackbarOpen',
      'setSnackbarText'
		]),
    setUrlHash(hash) {
			window.location.hash = hash
    },
    submitForgotPassword() {
			let url = '/rest-auth/password/reset/'
			axios
				.post(url, {
					email: this.email
				})
				.then(response => {
          this.setAuthModalOpen(false)
          this.setSnackbarOpen(true)
          this.setSnackbarText('You should receive an email to reset your password very soon!')
					console.log(response)
				})
				.catch(error => {
					console.error(error)
					this.setAuthModalOpen(false)
				})
		},
  }
}
</script>

<style lang="scss">
.password-reset__submit-button {
  border: 1px solid white;
  border-radius: 0;
  width: 230px;
  height: 50px;
  color: white!important;
  p {
    color: white!important;
    font-family: 'Nunito', sans-serif;
    font-weight: 200;
    font-size: 1.1em;
    margin: 0;
  }
  margin-bottom: 15px;
}
.password-reset__redirect-login {
  color: white!important;
  p {
    color: #FFF!important;
    font-family: 'Nunito', sans-serif;
    font-weight: 200;
    margin: 0;
  }
}
</style>
